import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HuwonpopPage } from './huwonpop';

@NgModule({
  declarations: [
    HuwonpopPage,
  ],
  imports: [
    IonicPageModule.forChild(HuwonpopPage),
  ],
})
export class HuwonpopPageModule {}



// WEBPACK FOOTER //
// ./src/pages/huwonpop/huwonpop.module.ts